import { useSetAtom } from "jotai";
import { useEffect } from "react";
import {
    activeGroupJobAtom, 
    addNewAngleLoaderAtom, 
    coverageAtom, 
    currentJobDetailsAtom, 
    fetchGroupJobDataLoadingAtom, 
    imagesDataAtom, 
    imagesURLsAtom, 
    instructionListDetailsAtom, 
    jobGroupIdAtom, 
    listingScoreDataAtom, 
    packageListDetailsAtom, 
    pimDetailsAtom, 
    pimSkuIdAtom, 
    positionAtom, 
    promptAtom, 
    selectedImageDataAtom, 
    transactionIdAtom, 
    triggerJobGroupCreationAtom, 
    uploadedImagesUrlAtom,
    instructionsPayloadAtom,
    packageSelectedDetailsAtom,
    createAnotherDataAtom,
    triggerAutoCsvDownloadWhenLoggedInAtom,
    triggerAutoPackageSubmissionWhenLoggedInAtom,
    customizeLifestyleButtonAtom,
    showInstructionIconAtom,
    lifeStyleGenerateImagesAtom,
    savedBrankitNameAtom,
    jobClosureDateAtom,
    lifestyleBackgroundLoaderAtom,
    imagesIdAtom,
    lifestyleCustomizeDataAtom,
    addNewAngleFlagAtom,
    selectedAnglesForRetouchingAtom,
    openFileUploaderAtom,
    openCustomPackageMenuAtom,
    totalCreditsCustomPerPackageAtom,
    customPackageQtyAtom,
    customPackageJourneyLoaderAtom,
    customPackageAtom,
    brandGuideAtom
} from './Atoms'

const useResetAll = () => {
  const jobCreation = useSetAtom(triggerJobGroupCreationAtom);
  const groupId = useSetAtom(jobGroupIdAtom);
  const activeGroup = useSetAtom(activeGroupJobAtom); 
  const images = useSetAtom(imagesDataAtom);
  const imagesUrls = useSetAtom(imagesURLsAtom);
  const lifeStylePosition = useSetAtom(positionAtom);
  const lifeStyleCoverage = useSetAtom(coverageAtom);
  const prompt = useSetAtom(promptAtom);
  const transactionId = useSetAtom(transactionIdAtom);
  const groupDataLoading = useSetAtom(fetchGroupJobDataLoadingAtom);
  const pimData = useSetAtom(pimDetailsAtom);
  const currentJob = useSetAtom(currentJobDetailsAtom);
  const packageList = useSetAtom(packageListDetailsAtom);
  const uploadedImages = useSetAtom(uploadedImagesUrlAtom);
  const addAngleLoader = useSetAtom(addNewAngleLoaderAtom);
  const listingScore = useSetAtom(listingScoreDataAtom);
  const instructionsList = useSetAtom(instructionListDetailsAtom);
  const pimId = useSetAtom(pimSkuIdAtom);
  const selectedImages = useSetAtom(selectedImageDataAtom);
  const setInstructionsPayload = useSetAtom(instructionsPayloadAtom);
  const setPackageSelection = useSetAtom(packageSelectedDetailsAtom);
  const setCreateAnother = useSetAtom(createAnotherDataAtom);
  const setTrigger = useSetAtom(triggerAutoCsvDownloadWhenLoggedInAtom);
  const setAutoCsvDownloadTrigger = useSetAtom(triggerAutoPackageSubmissionWhenLoggedInAtom);
  const setCustomLifestyleButton = useSetAtom(customizeLifestyleButtonAtom);
  const setInstructionIcon = useSetAtom(showInstructionIconAtom);
  const setBackgroundImages = useSetAtom(lifeStyleGenerateImagesAtom);
  const setBrandkitName = useSetAtom(savedBrankitNameAtom);
  const setJobCloseDate = useSetAtom(jobClosureDateAtom);
  const setLifestyleBackgroundLoader = useSetAtom(lifestyleBackgroundLoaderAtom);
  const setImagesId = useSetAtom(imagesIdAtom);
  const setCustomizeItData = useSetAtom(lifestyleCustomizeDataAtom);
  const setAddNewAngleFlag = useSetAtom(addNewAngleFlagAtom);
  const setSelectedAnglesForRetouching = useSetAtom(selectedAnglesForRetouchingAtom);
  const setOpenFileUploader = useSetAtom(openFileUploaderAtom);
  const setOpenCustomPackge = useSetAtom(openCustomPackageMenuAtom);
  const setTotalCreditsCustomPackage = useSetAtom(totalCreditsCustomPerPackageAtom);
  const setPackageQty = useSetAtom(customPackageQtyAtom);
  const setCustomPackageJourneyLoader = useSetAtom(customPackageJourneyLoaderAtom);
  const setCustomPackage = useSetAtom(customPackageAtom);
  const setBrandGuideAtom = useSetAtom(brandGuideAtom);

  const resetStates = () => {
    jobCreation(null);
    groupId("");
    activeGroup(null);
    images([]);
    imagesUrls([]);
    lifeStylePosition(null);
    lifeStyleCoverage(null);
    prompt("");
    transactionId("");
    groupDataLoading(false);
    pimData(null);
    currentJob(null);
    packageList([]);
    uploadedImages([]);
    addAngleLoader(false);
    listingScore([]);
    instructionsList([]);
    pimId("");
    selectedImages([]);
    setInstructionsPayload(null);
    setPackageSelection(null);
    setCreateAnother(null);
    setTrigger(false);
    setCustomLifestyleButton(false);
    setInstructionIcon(false)
    setBackgroundImages([]);
    setBrandkitName("");
    setJobCloseDate(null);
    setLifestyleBackgroundLoader(false);
    setAutoCsvDownloadTrigger(false);
    setImagesId([]);
    setCustomizeItData({});
    setAddNewAngleFlag(false);
    setSelectedAnglesForRetouching(0);
    setOpenFileUploader(false);
    setOpenCustomPackge(false);
    setTotalCreditsCustomPackage(0);
    setPackageQty({});
    setCustomPackageJourneyLoader(false);
    setCustomPackage(false);
    setBrandGuideAtom(null);
  }

 return {resetStates};
};

export default useResetAll;